/**
 * Temporary stand-in for the HFOMS trade day.
 * Only days whose orders move at least one status count. Expired or rejected days with no fill stay off the list.
 * Newest first. Remove this when the strip follows the real trade day.
 */
export const OMS_SIMULATED_DATES = [
  '2026-09-23',
  '2026-09-17',
  '2026-09-16',
  '2026-09-15',
  '2026-01-22',
  '2026-01-21',
  '2025-12-09',
  '2025-12-05',
  '2025-11-26',
  '2025-11-25',
  '2025-11-24',
  '2025-11-20',
  '2024-10-11',
  '2023-12-27',
  '2023-08-18',
  '2021-08-10',
  '2020-12-23',
  '2020-12-07',
  '2020-11-09',
] as const;
